import logo from './logo.svg';
import './App.css';
import GenesisLanding from './page/main';

function App() {
  return (
    <div className="App">
      <GenesisLanding />
    </div>
  );
}

export default App;
